<template>
  <div class="charging-voucher-page">
    <div v-if="curNav === 'CharingCenter'">
      <CharingCenter />
    </div>
    <div v-else-if="curNav === 'MyCoupons'">
      <MyCoupons />
    </div>
    <div v-else-if="curNav === 'PersonalCenter'">
      <PersonalCenter />
    </div>

    <!-- 底部导航栏 -->
    <BottomNavBar
      v-if="showBottomNavBar"
      :options="navBarOptions"
      :cur-nav="curNav"
      @click="handleNavBarClick"
    />
  </div>
</template>

<script>
import BottomNavBar from './components/BottomNavBar.vue';
import CharingCenter from './components/CharingCenter.vue';
import MyCoupons from './components/MyCoupons.vue';
import PersonalCenter from './components/PersonalCenter.vue';
import IconCharingCenterDefault from '@/assets/img/chargingVoucher/home-default.png';
import IconCharingCenterSelected from '@/assets/img/chargingVoucher/home-selected.png';
import IconMyCouponsDefault from '@/assets/img/chargingVoucher/my-coupons-default.png';
import IconMyCouponsSelected from '@/assets/img/chargingVoucher/my-coupons-selected.png';
import IconPersonalCenterDefault from '@/assets/img/chargingVoucher/user-default.png';
import IconPersonalCenterSelected from '@/assets/img/chargingVoucher/user-selected.png';
import tokenMixin from './mixins/tokenMixin.js';

export default {
  name: 'ChargingVoucher',
  components: {
    BottomNavBar,
    CharingCenter,
    MyCoupons,
    PersonalCenter
  },
  mixins: [tokenMixin],
  data() {
    return {
      curNav: '',
      navBarOptions: [
        {
          text: '购券中心',
          defaultIcon: IconCharingCenterDefault,
          selectedIcon: IconCharingCenterSelected,
          key: 'CharingCenter'
        },
        {
          text: '我的充电券',
          defaultIcon: IconMyCouponsDefault,
          selectedIcon: IconMyCouponsSelected,
          key: 'MyCoupons'
        },
        {
          text: '个人中心',
          defaultIcon: IconPersonalCenterDefault,
          selectedIcon: IconPersonalCenterSelected,
          key: 'PersonalCenter'
        }
      ],
      source: ''
    };
  },
  computed: {
    showBottomNavBar() {
      return !(this.source === 'xmcf');
    }
  },
  mounted() {
    const navKey =
      localStorage.getItem('_nav') || this.navBarOptions[0]?.key || '';
    this.handleNavBarClick(navKey);
    localStorage.removeItem('_nav');
  },
  beforeDestroy() {
    localStorage.setItem('_nav', this.curNav);
  },
  methods: {
    init() {
      const query = this.$route.query;
      // 处理从小程序入口跳转过来
      if (Object.keys(query).length) {
        // 基础信息
        const phone = this.$route.query.phone || '';
        const aseUserId = this.$route.query.aseUserId || '';
        if (phone) localStorage.setItem('_phone', phone);
        if (aseUserId) localStorage.setItem('_aseUserId', aseUserId);
        // 支付回调
        const orderNo = this.$route.query.orderNo || '';
        const isCallBack = this.$route.query.isCallBack || '';
        if (orderNo) localStorage.setItem('_orderNo', orderNo);
        if (isCallBack) localStorage.setItem('_isCallBack', isCallBack);
        // 跳转来源
        const source = this.$route.query.source || '';
        if (source) localStorage.setItem('_source', source);

        this.$router.replace({
          name: 'ChargingVoucher'
        });
      }
      this.source = localStorage.getItem('_source') || '';
    },
    handleNavBarClick(key) {
      this.curNav = key;
      const nav = this.navBarOptions.find((item) => item.key === key);
      document.title = nav?.text || '';
      console.log(this.curNav);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './styles/chargingVoucherCenter.scss';
</style>
